
import { computed, defineComponent, onBeforeUnmount, SetupContext, watch } from 'vue';
import { TButton, TIcon } from '@tencent/web-vbui';
export default defineComponent({
  components: {
    TButton,
    TIcon,
  },
  emits: ['update:modelValue', 'close', 'cancel', 'confirm'],
  props: {
    modelValue: { type: Boolean, default: false },
    content: { type: [String, Array], default: '' },
    footer: { type: Boolean, default: true },
    confirmText: { type: String, default: '我知道了' },
  },
  setup(props, context: SetupContext) {
    const show = () => context.emit('update:modelValue', true);
    const hide = () => context.emit('update:modelValue', false);
    const onTapByConfirm = (event: unknown) => {
      hide();
      context.emit('confirm', event);
    };
    const onTapByClose = (event: unknown) => {
      hide();
      context.emit('close', event);
    };
    // 监听modelValue, 实现内部的显示、隐藏逻辑
    const stopWatch = watch(
      () => props.modelValue,
      (newValue) => {
        newValue ? show() : hide();
      },
    );
    onBeforeUnmount(() => {
      hide();
      stopWatch();
    });

    const getContent = computed(() => {
      if (props.content && typeof props.content === 'string') {
        return props.content.split('\\n');
      }
      return props.content;
    });

    return {
      getContent,
      onTapByConfirm,
      onTapByClose,
    };
  },
});
